<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">User List</span>
        <button
          class="pull-right btn btn-primary"
          @click="add_user_product_model = !add_user_product_model"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <b-modal v-model="add_user_product_model" title="Add User" hide-footer="">
        <div v-if="addUserLoading">
          <div class="col-md-12 text-center">
            <sweetalert-icon :icon="loadingType" />
          </div>
          <div class="col-md-12 text-center">
            <h3 class="text-center">{{ loadingMessage }}</h3>
          </div>
        </div>
        <b-form v-on:submit.prevent="addUser" v-if="!addUserLoading">
          <b-form-group label="Select Role:">
            <b-form-select
              v-model="newUser.roleId"
              required
              class="form-control"
              :options="roleList"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Name">
            <b-form-input
              v-model="newUser.name"
              type="text"
              required
              class="form-control"
              placeholder="Enter User Name"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Email Id:">
            <b-form-input
              v-model="newUser.email"
              type="email"
              required
              class="form-control"
              placeholder="Enter Email Address"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Phone No:">
            <b-form-input
              v-model="newUser.number"
              type="number"
              required
              class="form-control"
              placeholder="Enter Phone Number"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Address:">
            <b-form-textarea
              v-model="newUser.address"
              placeholder="Enter User Address"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <button type="submit" class="btn btn-success btn-lg">Save</button>
        </b-form>
      </b-modal>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Role</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in VendorUsers" :key="index">
                <td>{{ ++index }}</td>
                <td>
                  {{ user.name }}
                </td>
                <td>
                  {{ user.email }}
                </td>
                <td>
                  {{ user.number }}
                </td>
                <td>
                  {{ user.address }}
                </td>
                <td>
                  {{ getRoleById(user.roleId) }}
                </td>
                <td>
                  <b-badge variant="success" v-if="user.status == true"
                    >Active</b-badge
                  >
                  <b-badge variant="danger" v-else>Deactive</b-badge>
                </td>
                <td>
                  <span v-if="user.status == false" class="text-center mr-1">
                    <button
                      class="btn btn-sm btn-success"
                      @click="Approve(user, 'true')"
                      v-b-tooltip.hover
                      title="Activate"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                  </span>
                  <span v-else-if="user.status == true" class="mr-1">
                    <button
                      class="btn btn-sm btn-danger"
                      @click="Approve(product, 'false')"
                      v-b-tooltip.hover
                      title="Deactivate"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { mapGetters } from "vuex";
import { dbFs, checkUser } from "@/modules/database";
import { vendorUserRegistration } from "@/modules/auth";
export default {
  data() {
    return {
      loading: false,
      dataTable: null,
      addUserLoading: false,
      add_user_product_model: false,
      VendorUsers: [],
      loadingType: "loading",
      loadingMessage: "Uploading",
      roleList: [],
      newUser: {
        address: "",
        email: "",
        name: "",
        number: null,
        roleId: null,
        status: false,
        vendorId: this.$route.params.vendorId
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.setupFirebaseReading();
    this.getRoles();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind(
        "VendorUsers",
        dbFs
          .collection("user")
          .where("vendorId", "==", this.$route.params.vendorId)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.forDataTable();
        });
    },
    async getLessThan500KOrMoreThan1M5() {
      const citiesRef = dbFs.collection("userRoles");
      const vendor = citiesRef.where("type", "==", "vendor").get();
      const delivery = citiesRef.where("type", "==", "delivery").get();
      const [vendorQuerySnapshot, deliveryQuerySnapshot] = await Promise.all([
        vendor,
        delivery
      ]);
      const vendorCitiesArray = vendorQuerySnapshot.docs;
      const deliveryArray = deliveryQuerySnapshot.docs;
      const fulldata = vendorCitiesArray.concat(deliveryArray);
      return fulldata;
    },
    getRoles() {
      this.loading = true;
      let role = [];
      role.push({
        value: null,
        text: "Select Role"
      });
      this.getLessThan500KOrMoreThan1M5()
        .then(querySnapshot => {
          querySnapshot.forEach(function(doc) {
            role.push({
              value: doc.id,
              text: doc.data().name
            });
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.roleList = role;
          this.loading = false;
        });
    },
    getRoleById(id, dataType = "name") {
      let roles = {
        text: "Role Not Found"
      };
      for (const cusKey of Object.keys(this.roleList)) {
        const category = this.roleList[cusKey];
        if (id == category.value) {
          roles = category;
        }
      }
      if (dataType == "name") {
        return roles.text;
      }
    },
    addUser() {
      this.addUserLoading = true;
      this.loadingMessage = "Adding User";
      checkUser(this.newUser.email)
        .then(() => {
          console.log("test");
          vendorUserRegistration(
            this.newUser.email,
            Math.random()
              .toString(36)
              .slice(2),
            this.newUser
          ).then(() => {
            this.loadingType = "success";
            this.loadingMessage = "User Added Successfull";
          });
        })
        .catch(error => {
          console.log(error);
          this.loadingType = "error";
          this.loadingMessage = error;
        })
        .finally(() => {
          setTimeout(() => {
            this.add_user_product_model = false;
            this.addUserLoading = false;
            this.newUser = {
              address: "",
              email: "",
              name: "",
              number: null,
              roleId: null,
              status: false,
              vendorId: this.$route.params.vendorId
            };
          }, 3000);
        });
    },
    Approve(user, type) {
      let status = false;
      if (type == "true") {
        status = true;
      }
      let update = {
        status: status
      };
      dbFs
        .collection("user")
        .doc(user.id)
        .set(update, { merge: true })
        .then(() => {});
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [10, 20]
      });
    }
  }
};
</script>

<style scoped></style>
